module.exports = __webpack_public_path__ + "assets/map-white.b05880f1.svg";